class ManagePurchaseTopblockController {
  constructor (VehicleService, UserService, $log, $state) {
    'ngInject'
    this.vehicleService = VehicleService
    this.userService = UserService
    this.$state = $state
    this.$log = $log
    this.isLogged = this.userService.getCurrentToken()
    if (this.isLogged) {
      this.loaded = this.init()
    }
  }

  init () {
    return this.vehicleService.getCurrentUserVehicles()
    .then((vehicles) => {
      this.vehicles = vehicles.length > 0
      return this.vehicleService.getCurrentSelectedVehicle()
    })
    .then((v) => {
      this.vehicle = v
      return this.vehicle
    })
    .catch((err) => {
      this.$log.error('Unable to load Navbar', err)
    })
  }

  goToCatalog () {
    this.$state.go('vehicle.catalog', {vin: this.vehicle.vin, sync: true})
  }

}

export default ManagePurchaseTopblockController



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/common/manage-purchase-topblock/manage-purchase-topblock.controller.js